<template>
  <div v-for="[key, item] in Array.from(items.entries()).sort((a, b) => a[1].code < b[1].code ? -1 : 1)"
       :key="key">
    <v-list-group v-if="(item.type === 'group') || (item.type === 'subgroup')" :key="item.code" :value="item.code">
      <template v-slot:activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="mdi-map"
                     :title="item.code + ' ' + item.description"></v-list-item>
      </template>
      <v-lazy transition="fade-transition">
        <div>
          <RecursiveDrugsMenu :items="item.children"></RecursiveDrugsMenu>
          <v-divider v-if="item.type === 'group'"></v-divider>
        </div>
      </v-lazy>
    </v-list-group>
    <v-list-item  v-if="item.type === 'leaf'"
                  :key="item.code"
                  :value="item.code"
                  :title="item.code + ' ' + item.description"
                  @click="$router.push(({name: 'SocialstyrelsenGenericDrugs', params: {
                                      atc: item.code.split('/').join('_'),
                                      atcPresentation: item.code,
                                      atcDescription: item.description}}))">
    </v-list-item>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'RecursiveDrugsMenu',
  props: {
    items: Map
  }
});
</script>
